/// <reference path="WebService.ts" />

interface WebService
{
    removeBank( bank:Bank, completion:any ) : void ;
    removeBankAccount( account:BankAccount, completion:any ) : void ;
    importBankMovements(file:any, account:BankAccount, type:string, completion:any) : void ;
}

WebService.prototype.removeBank = function( bank:Bank, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/bank/" + bank.identifier;
    let r = new DLRequest ( url_str, null, "DELETE" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion();
    } );
}

WebService.prototype.removeBankAccount = function( account:BankAccount, completion:any ) : void
{
    const url_str = this.integratorURL + "/schema/" + this.scheme + "/bank-account/" + account.identifier;
    let r = new DLRequest ( url_str, null, "DELETE" );
    r.execute( (json:any, error:any) => {
        if (error) {
            AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR","ERROR"), error);
            return;
        }

        if (completion) completion();
    } );
}

WebService.prototype.importBankMovements = function ( file:any, account:BankAccount, type:string, completion:any ) {    
    const cmd = new WebServiceCommand(this.integratorURL, "/schema/" + this.identifier + "/import/bank-movements/" + account.identifier + "/" + type);
    cmd.method = "PUT";
    cmd.blobData = file;

    cmd.execute(this, function (code, json) {
        if (completion != null) completion(code == 200);
    });                        
}
